import { FC, memo, useMemo, ReactNode } from 'react'
import * as styles from 'components/features/pfm/RecentTransactionsModule/RecentTransactionsModule.styl'
import { Guards } from 'interfaces/guards'
import { recentTransactionsGuard } from 'guards/moneyflowGuards'
import { connectShadedLoadable } from 'helpers/loadableHelpers'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { recentTransactionsSelector } from 'selectors/moneyflowSelectors'
import { TransactionNarrow } from 'components/features/pfm/TransactionNarrow/TransactionNarrow'
import { TransactionNarrowGroup } from 'components/features/pfm/TransactionNarrowGroup/TransactionNarrowGroup'
import { formatRelativeDate } from 'helpers/dateTimeHelpers'
import { DATE_FORMAT_READABLE } from 'constants/datetime'
import { NoAccountsCard } from 'components/features/pfm/NoAccountsCard/NoAccountsCard'

type RecentTransactionsModuleProps = {

}

const RecentTransactionsComponent: FC<RecentTransactionsModuleProps> = memo((props) => {
  const {} = props

  const transactions = useStoreSelector(recentTransactionsSelector)

  const transactionsChild = useMemo(() => {
    if (!transactions || !transactions.length) {
      return null
    }

    return transactions.reduce((acc, transaction) => {
      if (transaction.date !== acc.lastDate) {
        acc.lastDate = transaction.date
        acc.children.push(
          <TransactionNarrowGroup key={ `${ transaction.uid }date` } className={ styles.group }>
            { formatRelativeDate(transaction.date, DATE_FORMAT_READABLE) }
          </TransactionNarrowGroup>
        )
      }

      acc.children.push(
        <div
          key={ transaction.uid }
          className={ styles.transaction }
        >
          <TransactionNarrow
            transaction={ transaction }
            hideEdit
            hideDate
            showStatus={ transaction.status === 'pending' }
          />
        </div>
      )

      return acc
    }, {
      lastDate: '',
      children: [] as ReactNode[],
    }).children
  }, [transactions])

  if (!transactions || !transactions.length || !transactionsChild) {
    return (
      <NoAccountsCard>
        See all your transactions in one place.
      </NoAccountsCard>
    )
  }

  return (
    <div className={ styles.recentTransactionsModule }>
      { transactionsChild }
    </div>
  )
})


const transactionsGuards: Guards<RecentTransactionsModuleProps> = [
  recentTransactionsGuard,
]

export const RecentTransactionsModule = connectShadedLoadable<
  {}, {}, RecentTransactionsModuleProps
>(() => () => ({}), () => ({}), transactionsGuards)(RecentTransactionsComponent)
